module.exports = __webpack_public_path__ + "img/icon-arrow-right-yellow.ff1e5505.svg";